/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/reducerGoCampaign_PoliticalDistricts.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for Political Districts
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Wednesday, July 10, 2019 - 12:15:48 AM (CST)
 *  
 *  Notes:
 *
 *  
 *  Revisions:
 *      07/10/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    POLITICALDISTRICT_LIST_CONTAINER_LOADED,
    POLITICALDISTRICT_LIST_CONTAINER_UNLOADED,
    POLITICALDISTRICT_LIST_TABLE_LOADED,
    POLITICALDISTRICT_LIST_TABLE_UNLOADED,

    POLITICALDISTRICT_LIST_CHANGE_GROUP,
    POLITICALDISTRICT_SET_GROUP_SELECT,

    POLITICALDISTRICT_SELECT_ROW,
    POLITICALDISTRICT_ADD,
    POLITICALDISTRICT_EDIT,
    POLITICALDISTRICT_DELETE,
    POLITICALDISTRICT_OPEN_WARNING,
    POLITICALDISTRICT_CLOSE_WARNING,
    POLITICALDISTRICT_DELETE_DISABLE,

    POLITICALDISTRICT_EDIT_CONTAINER_LOADED,
    POLITICALDISTRICT_EDIT_CONTAINER_UNLOADED,
    POLITICALDISTRICT_EDIT_FORM_LOADED,
    POLITICALDISTRICT_EDIT_FORM_UNLOADED,
    POLITICALDISTRICT_EDIT_DATA_LOAD,
    POLITICALDISTRICT_EDIT_CONTAINER_SUBMIT,
    POLITICALDISTRICT_EDIT_CONTAINER_CANCEL
} from '../constants/actionTypeGoCampaign_PoliticalDistricts';

const defaultState = {
    refreshList: false,
    danger: false,
    politicaldistrictid: 0,
    politicaldistrictgroupid: 0,
    countryid: 0,
    stateid: 0,
    countyid: 0,
    cityid: 0,
    zipcodeid: 0,
    name: '',
    description: '',
    createdate: '',
    modifydate: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case POLITICALDISTRICT_LIST_CONTAINER_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                politicaldistricts: action.payload[0] ? action.payload[0].records : null,
                countries: action.payload[1] ? action.payload[1].records : null,
                states: action.payload[2] ? action.payload[2].records : null,
                politicaldistrictgroups: action.payload[3] ? action.payload[3].records : null,
            }
        case POLITICALDISTRICT_LIST_TABLE_LOADED:
            return {
                ...state
            }
        case POLITICALDISTRICT_LIST_CHANGE_GROUP:
            return {
                ...state,
                [action.key]: action.payload ? action.payload : []
            }
        case POLITICALDISTRICT_SELECT_ROW:
            return {
                ...state,
                politicaldistrictid: action.id
            }
        case POLITICALDISTRICT_ADD:
            return {
                ...state
            }
        case POLITICALDISTRICT_EDIT:
            return {
                ...state,
                politicaldistrictid: action.id
            }
        case POLITICALDISTRICT_DELETE:
            return {
                ...state,
                politicaldistrictid: null
            }
        case POLITICALDISTRICT_DELETE_DISABLE:
            return {
                ...state,
                disableDelete: action.disabled
            }
        case POLITICALDISTRICT_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case POLITICALDISTRICT_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case POLITICALDISTRICT_EDIT_CONTAINER_LOADED:
        case POLITICALDISTRICT_EDIT_DATA_LOAD:
            return {
                ...state,
                politicaldistrictid: action.payload[0] ? action.payload[0].politicaldistrictid : 0,
                politicaldistrictgroupid: action.payload[1] ? action.payload[1].politicaldistrictgroupid : action.payload[0] ? action.payload[0].politicaldistrictgroupid : 0,
                politicaldistrictgroup: action.payload[1] ? action.payload[1].name : action.payload[0] ? action.payload[0].politicaldistrictgroup : '',
                countryid: action.payload[1] ? action.payload[1].countryid : action.payload[0] ? action.payload[0].countryid : 0,
                country: action.payload[1] ? action.payload[1].country : action.payload[0] ? action.payload[0].country : '',
                stateid: action.payload[1] ? action.payload[1].stateid : action.payload[0] ? action.payload[0].stateid : 0,
                state: action.payload[1] ? action.payload[1].state : action.payload[0] ? action.payload[0].state : '',
                countyid: action.payload[1] ? action.payload[1].countyid : action.payload[0] ? action.payload[0].countyid : 0,
                county: action.payload[1] ? action.payload[1].county : action.payload[0] ? action.payload[0].county : '',
                cityid: action.payload[1] ? action.payload[1].cityid : action.payload[0] ? action.payload[0].cityid : 0,
                city: action.payload[1] ? action.payload[1].city : action.payload[0] ? action.payload[0].city : '',
                zipcodeid: action.payload[1] ? action.payload[1].zipcodeid : action.payload[0] ? action.payload[0].zipcodeid : 0,
                zipcode: action.payload[1] ? action.payload[1].zipcode : action.payload[0] ? action.payload[0].zipcode : '',
                name: action.payload[0] ? action.payload[0].name : '',
                description: action.payload[0] ? action.payload[0].description : '',
                createdate: action.payload[0] ? action.payload[0].createdate : '',
                modifydate: action.payload[0] ? action.payload[0].modifydate : ''
            }
        case POLITICALDISTRICT_SET_GROUP_SELECT:
            return {
                ...state,
                [action.key]: action.payload ? action.payload : []
            }
        case POLITICALDISTRICT_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case POLITICALDISTRICT_EDIT_CONTAINER_SUBMIT:
            return {
                ...state
            }
        case POLITICALDISTRICT_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case POLITICALDISTRICT_LIST_CONTAINER_UNLOADED:
        case POLITICALDISTRICT_LIST_TABLE_UNLOADED:
        case POLITICALDISTRICT_EDIT_CONTAINER_UNLOADED:
        case POLITICALDISTRICT_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/reducerGoCampaign_PoliticalDistricts.js